import React from 'react';
import { useForm } from '../../hooks/useForm';
import { consent, email } from '../../utils/validation';
import { FormField } from '../ui/FormField';
import { ConsentCheckbox } from '../ui/ConsentCheckbox';
import { FormStatus } from '../ui/FormStatus';
import { Button } from '../ui/Button';
type NewsletterFormProps = {
  purpose?: 'newsletter' | 'alerts';
  tone?: 'light' | 'dark';
};
const alertAreas = ['Board & Non-Executive', 'C-Suite', 'Executive & Director', 'Senior Management', 'Specialist Professional'];
export function NewsletterForm({
  purpose = 'newsletter',
  tone = 'dark'
}: NewsletterFormProps) {
  const {
    values,
    errors,
    status,
    setField,
    handleSubmit,
    reset
  } = useForm({
    email: '',
    interest: '',
    consent: false
  }, {
    email: email(),
    consent
  });
  return <form noValidate onSubmit={handleSubmit} className="space-y-4" aria-label={purpose === 'alerts' ? 'Job alerts signup' : 'Newsletter signup'} data-id="element-135" data-mp="200ckxl8ttlwe">
      <div className={`grid gap-3 ${purpose === 'alerts' ? 'sm:grid-cols-[1fr_1fr_auto]' : 'sm:grid-cols-[1fr_auto]'} sm:items-end`} data-id="element-136" data-mp="24z5pupa1s4ky">
        <FormField name="email" label="Email address" type="email" required tone={tone} autoComplete="email" placeholder="name@company.com" value={values.email} error={errors.email} onChange={v => setField('email', v)} data-id="element-137" data-mp="2zqx0ht4suucu" />
        {purpose === 'alerts' && <FormField name="interest" label="Role level" type="select" tone={tone} options={alertAreas} value={values.interest} onChange={v => setField('interest', v)} data-id="element-138" data-mp="3nfpv9m9oqw5v" />}
        <Button type="submit" size="lg" variant={tone === 'dark' ? 'gold' : 'navy'} className={errors.email ? 'sm:mb-7' : ''} data-id="element-139" data-mp="39obd1hnlqyzv">
          {purpose === 'alerts' ? 'Create alert' : 'Subscribe'}
        </Button>
      </div>
      <ConsentCheckbox tone={tone} checked={values.consent} error={errors.consent} onChange={v => setField('consent', v)} data-id="element-140" data-mp="59lbln3hvfiz">
        {purpose === 'alerts' ? 'Email me about relevant opportunities. I can unsubscribe at any time.' : 'Send me Corventa insights by email. I can unsubscribe at any time.'}
      </ConsentCheckbox>
      <FormStatus status={status} onReset={reset} data-id="element-141" data-mp="1urqijadgxf1i" />
    </form>;
}